import { updateWebAutomation } from "../webAutomationSlice";
import { store } from "../../../..";


const defaultPreferences = {
  automationTool: "",
  framework: "",
  programmingLanguage: "",
  codeStyle: "Page Object Model (POM)",
  testCaseType: "",
  projectType: "",
};

function getUpdatedPreferences(locationKey, key, value) {
  const state = store.getState();

  const currentAutomationPreferences = state["testAutomation"][locationKey]["webAutomation"]["automationPreferences"];

  return { ...currentAutomationPreferences, [key]: value };
}

export const createAutomationPreferences = (locationKey) => updateWebAutomation(locationKey, "automationPreferences", defaultPreferences);

export const setAutomationToolState = (locationKey, data) => {
  const updatedPreferences = getUpdatedPreferences(locationKey, "automationTool", data);

  return updateWebAutomation(locationKey, "automationPreferences", updatedPreferences);
};

export const setFrameworkState = (locationKey, data) => {
  const updatedPreferences = getUpdatedPreferences(locationKey, "framework", data);

  return updateWebAutomation(locationKey, "automationPreferences", updatedPreferences);
};

export const setProgrammingLanguageState = (locationKey, data) => {
  const updatedPreferences = getUpdatedPreferences(locationKey, "programmingLanguage", data);

  return updateWebAutomation(locationKey, "automationPreferences", updatedPreferences);
};

export const setCodeStyleState = (locationKey, data) => {
  const updatedPreferences = getUpdatedPreferences(locationKey, "codeStyle", data);

  return updateWebAutomation(locationKey, "automationPreferences", updatedPreferences);
};

export const setTestCaseTypeState = (locationKey, data) => {
  const updatedPreferences = getUpdatedPreferences(locationKey, "testCaseType", data);

  return updateWebAutomation(locationKey, "automationPreferences", updatedPreferences);
};

export const setProjectTypeState = (locationKey, data) => {
  const updatedPreferences = getUpdatedPreferences(locationKey, "projectType", data);

  return updateWebAutomation(locationKey, "automationPreferences", updatedPreferences);
};

export const resetAutomationPreferences = (locationKey) => updateWebAutomation(locationKey, "automationPreferences", defaultPreferences)